import React, { Component } from 'react';

export default class Container extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentImageKey: 0,
      animationClass: '',
    };
    this.lastImageKey = this.props.gravureData.images.length - 1;
  }

  onChangeImageKey(index) {
    this.setState(
      {
        currentImageKey: index,
        animationClass: '',
      },
      function () {
        this.setState({
          animationClass: 'u-ani-fadeIn',
        });
      }
    );
  }

  componentDidMount() {
    if ('lazyLoadInstance' in window) {
      window.lazyLoadInstance.update();
    }
  }

  componentDidUpdate() {
    if ('lazyLoadInstance' in window) {
      window.lazyLoadInstance.update();
    }
  }

  render() {
    const images = this.props.gravureData.images;
    const webpImages = this.props.gravureData.webp_images;
    const thumbImages = this.props.gravureData.thumb_images;
    const webpThumbImages = this.props.gravureData.webp_thumb_images;
    return (
      <div className="u-flex u-flex-row-reverse">
        <div className="column-1">
          <div className="gravure__main">
            <div className="gravure__img-wrap">
              <picture
                key={this.state.currentImageKey}
                className="gravure__img"
              >
                {webpImages[this.state.currentImageKey] && (
                  <source
                    srcset={webpImages[this.state.currentImageKey]}
                    type="image/webp"
                  />
                )}
                <img
                  className={`${this.state.animationClass} ofi`}
                  src={images[this.state.currentImageKey]}
                />
              </picture>
            </div>
            <div className="gravure__content">
              <div className="gravure__title">
                {this.props.gravureData.title}
              </div>
              {(() => {
                if (this.props.gravureData.comment) {
                  return (
                    <div
                      className="gravure__comment nk-font-readable"
                      dangerouslySetInnerHTML={{
                        __html: this.props.gravureData.comment,
                      }}
                    />
                  );
                }
              })()}
              <div className="gravure__timestamp">
                {this.props.gravureData.timestamp}
              </div>
            </div>
          </div>
        </div>
        <div className="column-2">
          <div className="gravure__thumb-images">
            {thumbImages.map((img_url, index) => (
              <div
                key={index}
                className={`gravure__thumb-box u-transparent--hovered${
                  this.state.currentImageKey == index ? ' current ' : ''
                }`}
                onClick={(e) => this.onChangeImageKey(index)}
              >
                <a
                  className="gravure__thumb-box-link"
                  href="javascript:void(0);"
                ></a>
                <picture key={index} className="gravure__thumb-img nk-skeleton">
                  {webpThumbImages[index] && (
                    <source srcset={webpThumbImages[index]} type="image/webp" />
                  )}
                  <img
                    className="nk-skeleton-img lazyload ofi"
                    src="/images/space.gif"
                    data-src={img_url}
                  />
                </picture>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}
